import React from 'react';
import { Image, View } from "react-native"
import Colors from '../constants/Colorsv2';
import { PublicPlayerProps } from '../store/types/auth_svc';
import { useDispatch } from 'react-redux';
import { Text, TouchableOpacity } from '../globalComponents/NativeOverrides';
import { V1_UPDATE_CHALLENGER } from '../store/actionsv1/types';


type ActiveChallengerProps = {
    challenger?:PublicPlayerProps,
    navigation:any
}

const ActiveChallenger = ({ challenger, navigation }:ActiveChallengerProps) => {

    const dispatch = useDispatch();

    if(!challenger){ return (<></>) }
    return (
        <View style={{ flexDirection:'row', alignItems:'center', backgroundColor:Colors.shades.shade600, padding:5 }}>
            <TouchableOpacity 
                style={{ flex:1, flexDirection:'row', alignItems:'center' }}
                onPress={() => navigation.navigate('SocialStack', { screen: 'H2H', params: { player_id: challenger.player_id } })}
                >
                <View>
                    <Image
                        source={{ uri: challenger.profile_pic && challenger.profile_pic != '' ? challenger.profile_pic : require('../assets/images/default-avatar.png')  }}
                        style={{ height:40, width:40, borderRadius:4 }}
                        resizeMode='cover'
                    />
                </View>
                <View style={{ flex:1, marginLeft:5 }}>
                    <Text size={14} color={Colors.brand.midnight} weight='bold'>You are challenging @{challenger.username}</Text>
                    <Text style={{ marginTop:2 }} size={14} color={Colors.brand.midnight} weight='regular'>Start an order and we will populate the H2H for you!</Text>
                    <Text style={{ marginTop:2 }} size={14} color={Colors.brand.electric} weight='regular'>View H2H History</Text>
                </View>
            </TouchableOpacity>
            <TouchableOpacity style={{ padding:15 }} onPress={() => {
                dispatch({ type:V1_UPDATE_CHALLENGER, player: undefined })
            }}>
                <Text size={18} color={Colors.utility.error} weight='bold' textAlign='center'>X</Text>
            </TouchableOpacity>
        </View>
        
    )
}

export default ActiveChallenger